module.exports = __webpack_public_path__ + "img/shipsen-man1.9db7f551.jpg";